import React from "react";
import { Modal, Button } from "antd";
import "./ConfirmationModelBox.css";
import { MODAL_CONSTANTS } from "../../../util/Constants";

const ConfirmationModalBox = ({
  visible,
  title,
  message,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal
      title={title || MODAL_CONSTANTS.TITLE}
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button
          key="confirm"
          type="primary"
          onClick={onConfirm}
          className="confirmation-modal-button-yes"
        >
          {MODAL_CONSTANTS.YES_BUTTON_TEXT}
        </Button>,
        <Button
          key="cancel"
          onClick={onCancel}
          className="confirmation-modal-button-no"
        >
          {MODAL_CONSTANTS.NO_BUTTON_TEXT}
        </Button>,
      ]}
    >
      <p>{message || MODAL_CONSTANTS.DEFAULT_MESSAGE}</p>
    </Modal>
  );
};

export default ConfirmationModalBox;
